<script>
    export default {
        name: 'invoices-details-item-edit',

        /**
         * The components the page can use.
         */
        components: {
        },

        /**
         * List passable properties
         *
         * @type {Array}
         */
        props: [
            'detail',
            'services',
            'iterator',
        ],

        /**
         * The data that can be used by the page.
         *
         * @returns {Object} The view-model data.
         */
        data() {
            return {
                item: this.detail
            };
        },

        /**
         * Prepare the component.
         */
        created() {
        },

        /**
         * Prepare the component.
         */
        mounted() {
        },

        /**
         * Clean after the component is destroyed.
         */
        destroyed(){
        },

        /**
         * Components computed values
         * For example: value : function(){},
         *
         * @type {Object}
         */
        computed: {
            units: {
                get() {
                    return this.item.units
                },
                set(value) {
                    this.item.units = value
                }
            },

            cost: {
                get() {
                    return _.isUndefined(this.item.cost) ? this.calculatedCost() : this.item.cost
                },
                set(value) {
                    this.item.cost = value
                }
            },

            service_id:{
                get() {
                    return this.item.service_id
                },
                set(value) {
                    this.item.service = _.find(this.services, {id:value})
                    this.item.service_id = value
                }
            },

        },

        /**
         * Components methods
         * Each element is a function()
         *
         * @type {Object}
         */
        methods:{
            /**
             * Toggle selection
             *
             * @return {void}
             */
            updateSelected() {
                this.item.is_selected = !!!this.item.is_selected
            },

            /**
             * Recalculate cost
             *
             * @return {float}
             */
            calculatedCost(){

                let amount = _.get(this.price(), 'pivot.amount', 0)

                amount = _.isEmpty(this.units) ? 0 : amount;

                if (this.priceIsSingular()){
                    amount = amount * (this.units || 0)
                }

                let price_id = _.get(this.price(), 'pivot.id')

                if (price_id) {
                    this.item.price_id = price_id
                }

                return amount;
            },

            /**
             * Get the price from the modifier
             *
             * @return float
             */
            price(){
                return _.first(this.prices())
            },

            /**
             * @return {array) Resolve the Prices from all modifiers
             */
            prices(){
                return _.filter(this.modifiers(), (modifier) => {

                    let units = this.units || 1

                    return modifier.pivot.modifier_id == this.detail.modifier_id &&
                           (
                                (units >= modifier.pivot.min_quantity && units <= modifier.pivot.max_quantity )
                                ||
                                (modifier.pivot.min_quantity == modifier.pivot.max_quantity)
                            )
                    }
                )
            },

            /**
             * True of the min matches max
             *
             * @return {boolean}
             */
            priceIsSingular(){

                let min_quantity = _.get(this.price(), 'pivot.min_quantity', 'min_quantity')
                let max_quantity = _.get(this.price(), 'pivot.max_quantity', 'max_quantity')

                return min_quantity == max_quantity
            },

            /**
             * @return {Boolean} check if the Detail is empty or not
             */
            isEmpty(){
                return !this.cost && !this.units
            },

            /**
             * Shorthand for the Service
             *
             * @return {Object}
             */
            service(){
                return this.item.service || {}
            },

            /**
             * @return {array) Resolve  modifiers from service
             */
            modifiers(){
                return _.get(this.service(), 'modifiers', [])
            },

            /**
             * @return {array} Resolve the modifiers from the
             */
            uniqueModifiers(){
                return _.uniqBy(this.modifiers(), 'id')
            },

            /**
             * True if count is less then 2
             *
             * @return {boolean}
             */
            disableModifiers(){
                return this.uniqueModifiers().length < 2
            },

            toggleLocked(){
                this.detail.is_locked = !this.detail.is_locked
            },
        },
    }
</script>

<template>
    <div class="form-row" v-if="detail">
        <input :name="'details[' + iterator + '][id]'" type="hidden" :value="detail.id">
        <div class="col-1 my-1">
            <label class="be-checkbox custom-control custom-checkbox">
                <input name="_selected"
                    autocomplete="off"
                    class="custom-control-input"
                    type="checkbox"
                    v-model="detail.is_selected"
                    >
                <span class="custom-control-label"></span>
            </label>
        </div>
        <div class="col-4 my-1">
            <select :name="'details[' + iterator + '][service_id]'"
                :disabled="detail.is_locked"
                v-model="service_id"
                class="form-control form-control-xs"
                required
                size="false">
                <option v-for="service in services" v-bind:value="service.id">
                    {{ service.label }}
                </option>
            </select>
        </div>
        <div class="col-2 my-1">
            <select :name="'details[' + iterator + '][modifier_id]'"
                :disabled="detail.is_locked"
                v-model="detail.modifier_id"
                class="form-control form-control-xs"
                required
                size="false">
                <option v-for="modifier in uniqueModifiers()" v-bind:value="modifier.pivot.modifier_id">
                    {{ modifier.label }}
                </option>
            </select>
        </div>
        <input :name="'details[' + iterator + '][price_id]'" type="hidden" :value="detail.price_id">
        <div class="col-2 my-1">
            <input :name="'details[' + iterator + '][units]'"
                :disabled="detail.is_locked"
                autocomplete="off"
                class="form-control form-control-xs text-right"
                type="text"
                v-model="item.units">
        </div>
        <div class="col-3 my-1">
            <div class="input-group">
                <input :name="'details[' + iterator + '][cost]'"
                    :disabled="detail.is_locked"
                    autocomplete="off"
                    class="form-control form-control-xs text-right"
                    type="text"
                    v-model="cost">
                <div class="input-group-append">
                    <button type="button" class="btn btn-secondary btn-xs" @click="toggleLocked()">
                        <i class="icon-th mdi text-muted zmdi-hc-lg"
                            :class="[detail.is_locked ? 'mdi-lock' : 'mdi-lock-open']"></i>
                    </button>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>




// WEBPACK FOOTER //
// resources/js/components/invoice/detail/Edit.vue